import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { getSelectedPracticeAreas } from '@redux/modules/practiceAreas';
import Store from '@redux';

import PracticeAreasContent from './components/PracticeAreasContent';

class PracticeAreas extends React.Component {
  constructor(props) {
    super(props);

    this.store = Store.get();
  }

  componentDidMount() {
    // A7/#233: in Salesforce (read-only) mode, do NOT load saved selections. Skipping
    // this dispatch stops the redux middleware from calling GetPracticeSubscriptions,
    // so there is no Salesforce read — keeping this lock independent of #235's re-key.
    if (!this.props.readOnly) {
      this.store.dispatch(getSelectedPracticeAreas());
    }
  }

  render() {
    return (
      <Provider store={this.store}>
        <PracticeAreasContent
          {...this.props}
        />
      </Provider>
    );
  }
}

PracticeAreas.propTypes = {
  readOnly: PropTypes.bool,
};

PracticeAreas.defaultProps = {
  readOnly: false,
};

PracticeAreas.displayName = 'PracticeAreas';

export default PracticeAreas;
